<template>
  <el-dialog
    width="800px"
    :visible="show"
    :title="title"
    @close="$emit('update:visible', false)"
  >
    <div class="fence-form">
      <FenceMap
        ref="refFenceMap"
        :formData.sync="formData"
        :pathId="pathId"
        :visible="visible"
        @drawConfirm="drawConfirm"
      />
      <div class="form">
        <div class="form-content">
          <el-form label-position="top" :model="formData">
            <el-form-item label="围栏名称">
              <el-input v-model="formData.pathName" placeholder="请输入"></el-input>
            </el-form-item>
            <!-- <el-form-item label="围栏类型">
              <el-select v-model="formData.status">
                <el-option label="政府部门" :value="1"></el-option>
                <el-option label="机场" :value="2"></el-option>
                <el-option label="火车站" :value="3"></el-option>
                <el-option label="客运站" :value="4"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="围栏类型">
              <el-select v-model="formData.status">
                <el-option label="进围栏" :value="1"></el-option>
                <el-option label="出围栏" :value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="围栏形状">
              <el-select v-model="formData.regionShape" @change="onChangeShape">
                <el-option label="多边形" :value="1"></el-option>
                <el-option label="圆形" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="车辆数" v-if="formData.pathType == 3">
              <el-input v-model="formData.number" type="number" />
            </el-form-item>
            <el-form-item label="设置报警时间(min)" >
              <el-input v-model="formData.settingTime" type="number" />
            </el-form-item>
            <el-form-item label="预警车辆数" v-if="formData.pathType == 3">
              <el-input v-model="formData.earlyWarnNumber" type="number" />
            </el-form-item>
            <el-form-item label="预警限停时间" v-if="formData.pathType == 2">
              <el-date-picker
                v-model="formData.earlyWarnLimitStopTime"
                type="datetime"
                placeholder="选择日期时间"
                value-format="yyyy-MM-dd hh:mm:ss"
              />
            </el-form-item>
            <el-form-item label="备注">
              <el-input v-model="formData.remark" type="textarea" :rows="3" />
            </el-form-item>
          </el-form>
        </div>
        <div class="footer">
          <el-button @click="$emit('update:visible',false)" size="small">取 消</el-button>
          <el-button @click="onConfirm" type="primary" size="small">确 认</el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import FenceMap from './FenceMap.vue';
import { getFormData } from '../params.js';
export default {
  props: {
    pathId: {
      type: Number,
      default:null
    },
    visible:{
      type:Boolean,
      default:false
    }
  },
  components:{
    FenceMap
  },
  data() {
    return {
      formData: getFormData(),
    };
  },
  computed:{
    title(){
      return this.pathId ? '修改围栏' : '新增围栏';
    },
    show:{
      get(){
        return this.visible;
      },
      set(val){
        this.$emit('update:visible',val);
      }
    }
  },
  watch: {
    show:{
      handler(val){
        !val && this.$refs.refFenceMap.clearMap();
        this.$nextTick(() => {
          val && this.init();
        })
      },
      deep:true
    }
  },
  methods: {
    async getPathInfo(){
      try{
        const { msg, code, data } = await this.$API.getPathInfo({ pathId:this.pathId });
        if(code !== 0) throw { msg };
        this.formData = data;
        this.$refs.refFenceMap.drawCover();
        console.log(this.formData,'this.formData');
      }catch(err){
        console.log(err);
      }
    },
    // 初始化数据
    init(){
      if(this.pathId){
        this.getPathInfo();
      }else{
        this.formData = getFormData();
        this.$sleep();
        this.$refs.refFenceMap.drawType('polygon');
      }
      console.log(this.formData);
    },
    // 请求参数
    getParams(){
      let params = {
        ...this.formData,
        pathFlag:''
      };
      if(this.pathId){
        params.pathId = this.pathId
      };
      return params;
    },
    // 保存
    async onConfirm(){
      try{
        if(!this.formData.pathName) throw { msg:'请输入围栏名称' };
        if(this.formData.status == 3 && this.formData.number === null) throw { msg:'请输入车辆数' };
        if(!this.formData.settingTime == null) throw { msg:'请选择设置报警时间' };
        if(!this.formData.lon && this.formData.regionShape == 2) throw { msg:'请绘制围栏' };
        if(!this.formData.pointList && this.formData.regionShape == 1) throw { msg:'请绘制围栏' };
        if(!this.formData.status == 3 && this.formData.earlyWarnNumber == null) throw { msg:'请输入预警车辆数' };
        if(!this.formData.status == 2 && !this.formData.earlyWarnLimitStopTime) throw { msg:'请输入预警限停时间' };

        const url = this.pathId ? 'updatePathInfo' : 'addPathInfo';

        const { msg, code } = await this.$API[url](this.getParams());

        if(code !== 0) throw { msg };
        this.$refs.refFenceMap.clearMap();
        this.$msg({ type:'success', message:msg });
        this.$emit('update:visible',false);
        this.$emit('onSuccess');
      }catch(err){
        this.$msg({
          type:'error',
          message:err.msg || err
        });
      }
      console.log(this.formData);
    },
    // 绘制成功回调
    drawConfirm(e){
      if(this.formData.regionShape == 1){
        this.formData.pointList = e;
      }else{
        this.formData.lon = e.lon;
        this.formData.lat = e.lat;
        this.formData.radius = e.radius;
      }
      console.log(this.formData,'this.formData');
    },
    onChangeShape(type){
      this.$refs.refFenceMap.onClear();
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__body{
  padding: 10px;
  border-top: 1px solid #EEE;
}
.fence-form{
  display: flex;
  justify-content: space-between;
  height: 600px;
  .form{
    width: calc(40% - 10px);
    height: 100%;
    display: flex;
    flex-direction: column;
    &-content{
      flex: 1;
      overflow-y: auto;
      @include scrollBar;
    }
    .footer{
      display: flex;
      justify-content: flex-end;
      margin-top: 10px;
    }
  }
  ::v-deep .el-form-item__content {
    width: unset !important;
  }
  ::v-deep .el-form-item__label {
    line-height: 26px;
    padding-bottom: 0;
  }
  .el-select,.el-date-editor{
    width: 100%;
  }
}
</style>
